import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import AssignTechnicianToTravel, {
    AssignTechnicianToTravelProps
} from "../../../pages/consumers/travel/components/AssignTechnicianToTravel";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AssignTechnicianToTravelProps {
}

type Props = OwnProps;

// @ts-ignore
const AssignTechnicianToTravelModal = NiceModal.create<Props>(({travel, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver title={header} onClose={handleClose} open={modal.visible} afterClose={modal.remove}>
            <AssignTechnicianToTravel travel={travel}/>
        </SlideOver>
    )
})

export default AssignTechnicianToTravelModal;
